export const userActions = ['Suspend User'];
